import { Dispatch, SetStateAction } from 'react';
import { CheckboxesOptions } from '../../../../../../../components/checkbox-select';
import {
  AggregateVectorParameterTypeInternal,
  MeasuredBy,
  PeriodWeeklyPeriod,
} from '../../../../../../../data-access/gql-types/graphql';
import { MeasurementRange } from '../../../../../../../types/measurement';
import { ChannelType, ValueEntry } from '../../../../../types';
import { ComparatorTariff } from '../../comparator/types/types';

export type ChartDataItem = {
  values: ChartDataValues[];
  time: string;
  tooltipTime: string;
  date?: number;
};

export type ChartDataValues = ValueEntry & {
  color: string;
  index: number;
  empty?: boolean;
  data?: Record<string, string | number | boolean>;
};

export type AnalysisHookParams = {
  channel: ChannelType;
  measurementChannel?: MeasuredBy;
};

export enum AvailableShortFormatEnum {
  HOURLY = 'HH:mm',
  WEEKLY = 'EEEEEE',
  MONTHLY = 'dd.LL',
  YEARLY = 'LL',
  TEN_YEARS = 'yyyy',
}

export enum AvailableLongFormatEnum {
  HOURLY = 'HH:mm',
  WEEKLY = 'eeee, dd.MM',
  MONTHLY = 'dd.LL.yyyy',
  YEARLY = 'LLLL',
  TEN_YEARS = 'yyyy',
}

export enum CostEnum {
  Cost = 'COST',
  BalancedCost = 'VECTOR_BALANCED_COST',
  PredictedCost = 'PREDICTED_COST',
}

export type EnergyStats = {
  color: string;
  count: number;
  max: number | null;
  sum: number;
  average?: number;
};

export type MeterDetailsState = {
  currentParameterIndex: number;
  setCurrentParameterIndex: Dispatch<SetStateAction<number>>;
  currentPhases: number[];
  setCurrentPhases: Dispatch<SetStateAction<number[]>>;
  measurementsPhaseIndex: number;
  setMeasurementsPhaseIndex: Dispatch<SetStateAction<number>>;
  activePeriod: PeriodWeeklyPeriod;
  setActivePeriod: Dispatch<SetStateAction<PeriodWeeklyPeriod>>;
  aggregatedParameters: CheckboxesOptions<AggregateVectorParameterTypeInternal>[];
  setAggregatedParameters: Dispatch<SetStateAction<CheckboxesOptions<AggregateVectorParameterTypeInternal>[]>>;
  activeMeasurementRange: MeasurementRange;
  setActiveMeasurementRange: Dispatch<SetStateAction<MeasurementRange>>;
  analysisPhases: number[];
  setAnalysisPhases: Dispatch<SetStateAction<number[]>>;
  comparatorTariffs: ComparatorTariff[];
  setComparatorTariffs: Dispatch<SetStateAction<ComparatorTariff[]>>;
  comparatorPage: number;
  setComparatorPage: Dispatch<SetStateAction<number>>;
  comparatorParam: AggregateVectorParameterTypeInternal;
  setComparatorParam: Dispatch<SetStateAction<AggregateVectorParameterTypeInternal>>;
};

export type RangeFromTo = {
  from: string;
  to: string;
};

export type SeriesMeasurementsChart = {
  type: AggregateVectorParameterTypeInternal;
  color: string;
  index: number;
};
